import SidebarLayout from '../components/SidebarLayout';
import React, { useState, useEffect, useContext } from 'react';
import AuthContext from '../context/AuthContext';
import CaregiverReportsTable from '../components/sections/Dashboard/CaregiverReportsTable';
import AccessWrapper from '../components/AccessWrapper';
import { useNavigate } from 'react-router-dom';

export default function CaregiverReports() {
  let { authTokens, user, postPageView, baseUrl } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  /* state variables to hold json data from the back-end */
  let [reports, setReports] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    getReports();
    postPageView(baseUrl, user.name, user.role, 'caregiver-reports');
  }, []);

  let getReports = async () => {
    setLoading(true);
    let response = await fetch(
      `${baseUrl}/mtss/checks/?caregiver_report=true`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + String(authTokens.access),
        },
      },
    );
    let data = await response.json();

    if (response.status === 200) {
      setReports(data);
      setLoading(false);
    } else if (response.status === 403) {
      setLoading(false);
      navigate('/unauthorized');
    }
  };

  return (
    <AccessWrapper
      allowedGroups={['mtss_member', 'mtss_supervisor', 'mtss_admin']}
    >
      <div>
        <SidebarLayout
          propComponents={
            <div className='bp-12 sm:pb-16 lg:pb-20'>
              <CaregiverReportsTable loading={loading} data={reports} />
            </div>
          }
          heading={'Caregiver Reports'}
          caregiverReportsCurrent={true}
        />
      </div>
    </AccessWrapper>
  );
}
